import React, { memo, useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getRecoBanner, getRecoGroup, getRecommendList, setScroll } from '../../actions/wallpaper';
import CardIndex from '../../card/CardIndex/CardIndex';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import Blank from './Blank';
import Nav from './Nav';
import styles from './WallpaperRecommend.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectWpRecoBanners = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.recoBanners,
);
const selectWpRecoGroups = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.recoGroups,
);

const getRecommendInfo = createSelector(
  state => {
    return state.wallpaper;
  },
  info => {
    return info.recommendInfo;
  },
);
const getBannerList = createSelector(
  state => {
    return state.wallpaper;
  },
  info => {
    return info.bannerList;
  },
);
const selectScroll = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.scroll;
  },
);
export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = history;
  const logInfoData = useSelector(selectLogInfo);
  const bannerList = useSelector(getBannerList);
  const recommendInfo = useSelector(getRecommendInfo);
  const bannersData = useSelector(selectWpRecoBanners);
  const groupsData = useSelector(selectWpRecoGroups);

  const [load, setLoad] = useState(null);
  const [contentElHeight, setContentElHeight] = useState(0);
  const scrollInfo = useSelector(selectScroll);
  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_Reco`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  /**
   * PUSH 滚动到最顶端
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (action === 'POP') {
      el.scrollTo(0, 0);
    }
  }, []);
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (contentElHeight && scrollInfo && scrollInfo.recommendScrollTop && action === 'POP') {
      if (contentElHeight <= scrollInfo.recommendScrollTop) {
        el.scrollTo(0, scrollInfo.recommendScrollTop - 20);
      } else {
        el.scrollTo(0, scrollInfo.recommendScrollTop);
      }
    }
  }, [contentElHeight]);

  useEffect(() => {
    if (
      action !== 'POP' ||
      !bannersData ||
      !bannersData.dataList ||
      !bannersData.dataList.length ||
      bannersData.pageType !== 'wallpaper'
    ) {
      dispatch(getRecoBanner({ pageType: 'wallpaper' }));
    }
  }, []);

  useEffect(() => {
    if (
      action !== 'POP' ||
      !groupsData ||
      groupsData.length === 0 ||
      (groupsData[0] && groupsData[0].pageType !== 'wallpaper')
    ) {
      dispatch(getRecoGroup({ pageType: 'wallpaper' }));
    }
  }, []);

  useEffect(() => {
    if (load === null) {
      setLoad(true);
    } else {
      setLoad(false);
    }
  }, [recommendInfo]);

  useEffect(() => {
    if (action !== 'POP' || !recommendInfo.list || recommendInfo.list.length === 0) {
      dispatch(
        getRecommendList({
          ...recommendInfo.pagenation,
          refresh: true,
          skip: 0,
        }),
      );
    }
    // history.replace(`${CONTEXT}/wprecommend?origin=0`);
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Reco',
        label: '',
        param2: {
          source: 'Wallpaper_Reco',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );

    dispatch(
      logPostInfo({
        source: 'Wallpaper_Reco',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    window.wpRecoOpenPageTime = +new Date();
    loggingPVDuration();
  }, []);

  // 详情页面浏览时长打桩每隔30秒打一次，限制3分钟内
  const loggingPVDuration = useCallback(() => {
    const spaceTime = 30;
    setTimeout(() => {
      const diffTime = +new Date() - window.wpRecoOpenPageTime;
      if (window.location.pathname.indexOf('wprecommend') > -1 && diffTime < 6 * spaceTime * 1000) {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'I_Wallpaper_Reco_ViewTime',
            label: '',
            param2: {
              source: `Wallpaper_Reco`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              time: parseInt(diffTime / 1000, 10),
            },
          }),
        );
        loggingPVDuration();
      }
    }, spaceTime * 1000);
  }, [dispatch]);

  // useEffect(() => {
  //   setContentElement(document.getElementById('container_content'));
  // }, [document.getElementById('container_content')]);

  const getClassType = (index = 0) => {
    const pos = index % 8;
    if (pos > 2 && pos < 5) {
      if (pos === 3) {
        return 'big_space';
      }
      return 'big';
    }
    if (pos === 1 || pos === 6) {
      return 'small_center';
    }
    return 'small';
  };

  const loadMore = async () => {
    dispatch(
      setScroll({
        recommendScrollTop: 0,
      }),
    );
    if (!recommendInfo.load) {
      await dispatch(
        getRecommendList({
          ...recommendInfo.pagenation,
          refresh: false,
        }),
      );
    }
  };
  const handleSaveScrollTop = () => {
    const el = document.getElementById('container_content');
    dispatch(
      setScroll({
        recommendScrollTop: el && el.scrollTop,
      }),
    );
  };

  const handleMeasureHeight = useCallback(node => {
    if (node) {
      setContentElHeight(node.clientHeight);
    }
  });

  if ((load || load === null) && action !== 'POP') {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.wp_content} onClick={handleSaveScrollTop} ref={handleMeasureHeight}>
      <Nav />

      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        hasMore={recommendInfo.list.length < recommendInfo.pagenation.count}
        loader={
          <div className="loader" key={0}>
            ----------加载中----------
          </div>
        }
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => document.getElementById('container_content')}
      >
        {bannersData && bannersData.dataList && bannersData.dataList.length > 0 && (
          <CardIndex
            data={bannersData}
            logInfo={{ tag: 'Wallpaper_Reco', pageSource: 'recommend' }}
          />
        )}
        {groupsData &&
          groupsData.length > 0 &&
          groupsData.map((item, i) => (
            <CardIndex
              data={item}
              key={i}
              logInfo={{ tag: 'Wallpaper_Reco', pageSource: 'recommend' }}
            />
          ))}
        <div className={styles.recommend_list}>
          {recommendInfo && recommendInfo.list.length > 0 && (
            <div className={styles.title}>{recommendInfo.name}</div>
          )}
          <div className={styles.recommend}>
            {recommendInfo.list.length > 0 &&
              recommendInfo.list.map((item, index) => {
                return (
                  <WallpaperCard
                    wallpaper={item}
                    key={index}
                    cardInfo={{
                      pageSource: 'recommend',
                      pageTage: '',
                      classType: getClassType(index),
                      isCollect: true,
                      isWallpaper: true,
                      isDeleteColl: false,
                      isDeleteUsed: false,
                      isPreview: true,
                    }}
                    logInfo={{ source: 'Wallpaper_Reco' }}
                  />
                );
              })}
          </div>
          {recommendInfo.list.length >= recommendInfo.pagenation.count &&
            recommendInfo.pagenation.count > 3 && (
              <div className="loader">----------到底啦----------</div>
            )}
        </div>
      </InfiniteScroll>
      {bannerList && bannerList.length < 1 && recommendInfo.pagenation.count < 1 && (
        <Blank load={recommendInfo.load} more />
      )}
      <ScrollTop />
    </div>
  );
});
